var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"no-border animated"},[_c('div',{staticClass:"item-header clearfix mb-3"},[_c('h5',{staticClass:"pull-left mb-0 mt-2"},[_vm._v(_vm._s(_vm.displayName))])]),_vm._v(" "),_c('div',{staticClass:"list-group mb-2"},[_c('b-nav',[_c('b-nav-item',{attrs:{"active":_vm.section === ''},on:{"click":function($event){_vm.section = ''}}},[_vm._v("Detail Issue")])],1)],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aee5d7f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/issues/DetailIndex.vue
// module id = 2377
// module chunks = 0